import { render, staticRenderFns } from "./panelRight.vue?vue&type=template&id=9b162b0c&scoped=true"
import script from "./panelRight.vue?vue&type=script&lang=js"
export * from "./panelRight.vue?vue&type=script&lang=js"
import style0 from "./panelRight.vue?vue&type=style&index=0&id=9b162b0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b162b0c",
  null
  
)

export default component.exports